import { css } from "styled-components/macro";

export enum FontFamily {
  text = "neue-haas-grotesk-text, sans-serif",
  titles = "neue-haas-grotesk-display, sans-serif",
  mono = "Roboto Mono, monoscpace",
}

const displayPro55 = css`
  font-family: ${FontFamily.titles};
  font-weight: 500;
  font-style: normal;
`;

const displayPro65 = css`
  font-family: ${FontFamily.titles};
  font-weight: 600;
  font-style: normal;
`;

const displayText55 = css`
  font-family: ${FontFamily.text};
  font-weight: 400;
  font-style: normal;
`;

const displayText65 = css`
  font-family: ${FontFamily.text};
  font-weight: 500;
`;

const displayText75 = css`
  font-family: ${FontFamily.text};
  font-weight: 700;
`;

const italic = css`
  font-family: ${FontFamily.text};
  font-style: italic;
`;

export const fontStyle = {
  regular: displayText55,
  medium: displayText65,
  bold: displayText75,
  italic,
};

export const titlefontStyle = {
  regular: displayPro55,
  bold: displayPro65,
};

export enum FontSizes {
  xxs = "10px",
  xs = "12px",
  s = "14px",
  m = "15px",
  l = "16px",
  xl = "18px",
  xxl = "20px",
  xxxl = "24px",
  huge = "48px",
}

const fontXxs = css`
  font-size: ${FontSizes.xxs};
`;

const fontXs = css`
  font-size: ${FontSizes.xs};
`;

const fontS = css`
  font-size: ${FontSizes.s};
`;

const fontBase = css`
  font-size: ${FontSizes.m};
`;

const fontL = css`
  font-size: ${FontSizes.l};
`;

const fontXl = css`
  font-size: ${FontSizes.xl};
`;

const fontXxl = css`
  font-size: ${FontSizes.xxl};
`;

const fontXxxl = css`
  font-size: ${FontSizes.xxxl};
`;

const fontHuge = css`
  font-size: clamp(${FontSizes.xxxl}, 5vw, ${FontSizes.huge});
`;

export const fontSize = {
  xxs: fontXxs,
  xs: fontXs,
  s: fontS,
  base: fontBase,
  l: fontL,
  xl: fontXl,
  xxl: fontXxl,
  xxxl: fontXxxl,
  huge: fontHuge,
};
